import { render, staticRenderFns } from "./Edit_brach.vue?vue&type=template&id=4d5f9f06&"
import script from "./Edit_brach.vue?vue&type=script&lang=js&"
export * from "./Edit_brach.vue?vue&type=script&lang=js&"
import style0 from "./Edit_brach.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports